import { Component } from '@angular/core';
import { SelectTemplate } from 'src/app/@amiga-pyme/select/templates/select.template';
import { ILaboratory, LABORATORY_TTL_ES } from '../../laboratory.interface';
import { LaboratoryService } from '../../laboratory.service';

@Component({
  selector: 'pg-laboratory-select',
  template: `
    <ami-select
      [settings]="table.settings"
      [data]="table.data"
      (selectedRowsEvent)="onReciveSelectedRows($event)"
    ></ami-select>
  `
})
export class LaboratorySelectComponent extends SelectTemplate {
  constructor(private serviceBase: LaboratoryService) {
    super(LABORATORY_TTL_ES, serviceBase);
  }

  ngOnInit() {
    this.table.settings = {
      title: LABORATORY_TTL_ES,
      columns: [{ header: 'Laboratorio', field: 'description' }]
    };
    this.initSubscriptions$();
  }

  initSubscriptions$() {
    this.suscriptionBase$ = this.serviceBase
      .getData$()
      .subscribe((data: ILaboratory[]) => {
        this.table.data = data;
      });
  }

  ngOnDestroy() {
    this.unsubscribeBase();
  }
}
